<template>
    <div class="row justify-content-center">
        <div
            v-for="device in devices"
            :key="device.hash"
            :class="[
                'col-xs-12 mb-3',
                `col-md-${devices.length <= 1 ? 12 : 6}`
            ]"
        >
            <ca-device
                :device="device"
                :fields="fields"
                :legend="false"
            ></ca-device>
        </div>
    </div>
</template>

<script>
import CaDevice from './Device.vue';

export default {
  props: ['devices', 'fields'],

  components: {
    CaDevice,
  },
};
</script>
